import classNames from 'classnames';
import * as React from 'react';

import Icon from '../../../common/icons/Icon';

import css from './BooksCheckInput.module.scss';

export enum InputType {
  Checkbox = 'checkbox',
  Radio = 'radio',
}

interface Props extends React.ComponentProps<'input'> {
  labelClassName?: string;
  type: InputType;
  onClick?: (e: React.MouseEvent) => void;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksCheckInput = ({
  children,
  className,
  labelClassName,
  type,
  onClick,
  onChange,
  ...attr
}: Props) => {
  const classes = classNames(css.BooksCheckInput, className);
  const labelClasses = classNames(css.BooksCheckInput__Label, labelClassName);

  return (
    <span className={classes}>
      <input
        {...attr}
        type={type}
        className={css.BooksCheckInput__Input}
        onClick={onClick}
        onChange={onChange}
      />
      <Icon name="checkmark" className={css.BooksCheckInput__Icon} />
      <span className={labelClasses}>{children}</span>
    </span>
  );
};

export default BooksCheckInput;
